import qs from 'qs'

import {SERVISE_URI} from '../../assets/settings/settinsrouters'

const url = `${SERVISE_URI}api/OAuth`
const appKey = 'BSR SSO'

const OauthModels = ({type, credential, accessToken, refreshToken, cp, tenant})=>{

    const headers = {
        'Basic':{
            'Accept': 'application/json',
            'content-type': 'application/x-www-form-urlencoded'
        },
        'Oauth':{
            'Accept': 'application/json',
            'content-type': 'application/x-www-form-urlencoded',
            'Authorization': `Basic ${credential}`,
        }
    }

    const TYPES_OAUTH = {
        'introspect':{
            method: 'post',
            url: `${url}/${type}`,
            headers: headers['Basic'],
            params:{
                'token': accessToken
            },
            data: qs.stringify({
                'client': appKey,
                'tenant': tenant
            })
        },
        'refresh':{
            method: 'post',
            url: `${url}/${type}`,
            headers: headers['Basic'],
            data: qs.stringify({
                'client': appKey,
                'refreshToken': refreshToken,
                'page': cp
            })
        }
    }

    return TYPES_OAUTH[type]
}

export default OauthModels